import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import { GlobalErrorHandler } from './components/GlobalErrorBoundary';
import './globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GlobalErrorHandler>
      <App />
    </GlobalErrorHandler>
  </React.StrictMode>
);
